<template>
  <div class="personal">
    <Nav />
    <div style="height: 80px"></div>
    <div class="personal-bottom">
      <!-- <div class="personal-bottom-top">
              <div class="personal-bottom-top-div"><div class="personal-bottom-top-div-div"></div><span style="margin-left:25px;">个人中心</span></div>
          </div> -->
      <div class="personal-bottom-bottom">
        <div class="personal-bottom-bottom-left">
            <slide @change="changeSlide"></slide>
        </div>
        <div class="personal-bottom-bottom-right">
          <div class="personal-bottom-bottom-right-top">
            <div class="personal-bottom-bottom-right-top-left"></div>
            <el-breadcrumb
              class="daohang"
              separator-class="el-icon-arrow-right"
            >
              <el-breadcrumb-item class="xinxi" :to="{ path: '/personalc' }">
                <span>我的信息</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item
                class="xinxi"
                :to="{ path: '/xiugaipersonalc' }"
              >
                <span>修改个人信息</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div
            class="personal-bottom-bottom-right-bottom"
            v-if="this.Xpc.userInfo"
          >
            <div
              style="
                display: flex;
                align-items: center;
                width: 100%;
                height: 84px;
                margin-top: 10px;
              "
            >
              <div>头像</div>
              <div class="touxiang">
                <el-upload
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :on-success="handleAvatarSuccesss"
                  :before-upload="beforeAvatarUploadd"
                  :http-request="aa"
                  name="avatar"
                  multiple
                >
                  <div v-if="imageUrl1" style="position: relative">
                    <img :src="imageUrl1" class="avatar" />
                    <div
                      style="
                        text-align: center;
                        line-height: 27px;
                        color: #d5d5d5;
                        width: 88px;
                        height: 27px;
                        position: absolute;
                        bottom: 0;
                        border-radius: 0px 0px 6px 6px;
                        background: rgba(0, 0, 0, 0.5);
                        font-size: 14px;
                      "
                    >
                      更改头像
                    </div>
                  </div>
                  <div v-else class="avatar-uploader-icon">
                    <!-- <i class="el-icon-plus" style="font-size:80px;"></i> -->
                    <img
                      style="
                        width: 100%;
                        height: 100%;
                        background-size: 100% 100%;
                      "
                      :src="img"
                      alt=""
                    />
                    <div
                      style="
                        width: 100%;
                        height: 27px;
                        line-height: 27px;
                        background: rgba(0, 0, 0, 0.5);
                        color: #ffffff;
                        position: absolute;
                        bottom: 0;
                      "
                    >
                      更改头像
                    </div>
                  </div>
                </el-upload>
              </div>
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                width: 100%;
                height: 84px;
                margin-top: 10px;
              "
            >
              <div>姓名</div>
              <div class="xingming">
                <el-input
                  v-if="this.Xpc.userInfo.nickname"
                  type="text"
                  style="margin-left: 50px"
                  :placeholder="Xpc.userInfo.nickname"
                  :disabled="isUpdateName ==0"
                  v-model="text"
                  maxlength="10"
                  show-word-limit
                >
                </el-input>
                <el-input
                  v-else
                  type="text"
                  style="margin-left: 50px"
                  placeholder="修改姓名"
                  v-model="text"
                  :disabled="isUpdateName ==0"
                  maxlength="10"
                  show-word-limit
                >
                </el-input>
              </div>
              <div style="color: #333; margin-left: 10px; font-size: 0.8rem">
                *30天内可以修改{{isUpdateName}}次
              </div>
            </div>
            <!-- <div
              style="
                display: flex;
                align-items: center;
                width: 100%;
                height: 84px;
                margin-top: 10px;
              "
              v-if="Xpc.userInfo"
            >
              <div >龙珠号</div>
              <div
                style="
                  color: #85878b;
                  padding-left: 15px;
                  margin-left: 35px;
                  width: 205px;
                  height: 40px;
                  border-radius: 5px 0 0 5px;

                  line-height: 40px;
                "
              >
                {{ Xpc.userInfo.account }}
              </div>
              <div
                @click="Xiugaizhanghao"
                style="
                  cursor: pointer;
                  color: #ffffff;
                  width: 109px;
                  height: 40px;
                  background: #721edc;
                  border-radius: 0 4px 4px 0;
                  text-align: center;
                  line-height: 41px;
                "
              >
                修改账号
              </div>
              <div style="color: #333; margin-left: 10px; font-size: 0.8rem">
                *半年可以改一次龙珠号
              </div>
            </div> -->
            <div
              style="
                display: flex;
                align-items: center;
                width: 100%;
                height: 84px;
                margin-top: 10px;
              "
            >
              <div>性别</div>
              <div style="display: flex; margin-left: 50px">
                <div
                  @click="Nan"
                  :class="{ 'activeGender': nan == true }"
                  style="
                    cursor: pointer;
                    background-color: #dadada;
                    color: #333;
                    text-align: center;
                    line-height: 40px;
                    height: 40px;

                    border-radius: 4px;
                    width: 56px;
                  "
                >
                  男
                </div>
                <div
                  @click="Nv"
                  :class="{ 'activeGender': nv == true }"
                  style="
                    cursor: pointer;
                    color: #333;
                    text-align: center;
                    margin-left: 20px;
                    line-height: 40px;
                    height: 40px;
                    border-radius: 4px;
                   background-color: #dadada;
                    width: 56px;
                  "
                >
                  女
                </div>
                <div
                  @click="Baomi"
                  :class="{ 'activeGender': baomi == true }"
                  style="
                    cursor: pointer;
                    background-color: #dadada;
                     color: #333;
                    text-align: center;
                    margin-left: 20px;
                    line-height: 40px;
                    height: 40px;
                    border-radius: 4px;
                    width: 56px;
                  "
                >
                  保密
                </div>
              </div>
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                width: 100%;
                height: 84px;
                margin-top: 10px;
              "
            >
              <div>生日</div>
              <div class="shengri">
                <el-date-picker
                  v-if="this.Xpc.userInfo.birthday"
                  style="margin-left: 50px"
                  v-model="value1"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
                <el-date-picker
                  v-else
                  style="margin-left: 50px"
                  v-model="value1"
                  type="date"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </div>
            </div>
            <div style="display: flex; width: 100%; margin-top: 10px">
              <div>个人简介</div>
              <div class="jianjie">
                <el-input
                  v-if="this.Xpc.userInfo.desc"
                  type="textarea"
                  :placeholder="Xpc.userInfo.desc"
                  v-model="textarea"
                  maxlength="100"
                  show-word-limit
                >
                </el-input>
                <el-input
                  v-else
                  type="textarea"
                  placeholder="请写入个人简介"
                  v-model="textarea"
                  maxlength="100"
                  show-word-limit
                >
                </el-input>
              </div>
            </div>
            <div style="width: 100%; margin-top: 50px">
              <div
                @click="Baocun"
                style="
                  cursor: pointer;
                  margin: 0 auto;
                  width: 176px;
                  height: 40px;
                  text-align: center;
                  line-height: 40px;
                  background: #721edc;
                  border-radius: 4px;
                  color: #ffffff;
                "
              >
                保存
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="tishi"
      style="
        position: absolute;
        top: 27%;
        left: 40%;
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      "
    >
      <img
        style="margin-top: 30px"
        src="https://oss.ansongqiubo.com/assets/personimage/tijiao.png"
        alt=""
      />
      <div style="margin-top: 20px">提交成功</div>
    </div>
    <div
      v-show="tishi2"
      style="
        position: absolute;
        top: 27%;
        left: 40%;
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      "
    >
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/cuowu2.png" alt="" />
      <div style="margin-top: 20px">提交失败</div>
    </div>
    <div
      v-show="tishi3"
      style="
        position: absolute;
        top: calc(50% - 142px / 2);
        left: calc(50% - 248px / 2);
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      "
    >
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/cuowu2.png" alt="" />
      <div style="margin-top: 20px">昵称重复</div>
    </div>
    <div
      v-show="tishi4"
      style="
        position: absolute;
        top: 27%;
        left: 40%;
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      "
    >
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/cuowu2.png" alt="" />
      <div style="margin-top: 20px">{{ tishi4Text }}</div>
    </div>
    <!-- <div v-show="tishi4" style="position: absolute;top: calc(50% - 142px/2);left: calc(50% - 248px/2);text-align: center;height: 142px;border-radius: 6px;background-color: rgba(255, 255, 255, 1);width: 248px;">
        <img style="margin-top:30px;" src="https://oss.ansongqiubo.com/assets/cuowu2.png" alt="">
        <div style="margin-top:20px;">{{tishi4Text}}</div>
    </div> -->
  </div>
</template>

<script>
import Nav from "../component/Nav.vue";
import slide from './template_slide.vue'
import qs from "qs";

export default {
  name: "App",
  data() {
    return {
      isUpdateName:1,
      b: 0,
      radio: 1,
      text: "",
      textarea: "",
      value1: "",
      nan: true,
      nv: false,
      baomi: false,
      cooke: "",
      imageUrl1: "",
      file: null,
      data: "",
      img: "",
      Xpc: [],
      tishi: false,
      tishi2: false,
      tishi3: false,
      tishi4: false,
      tishi4Text: "",
      activeName: 0,
    };
  },
  mounted() {
    // console.log(this.imageUrl1);
    this.cooke = localStorage.getItem("token");
    this.$axios
      .get(this.api + "/v1/profile/user", {
        params: {},
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
        },
      })
      .then((res) => {
        console.log(res);
        this.Xpc = res.data.data;
        this.img = res.data.data.userInfo.avatar;
        this.value1 = res.data.data.userInfo.birthday;
        this.text = res.data.data.userInfo.nickname;
        this.textarea = res.data.data.userInfo.desc;
        if (res.data.data.userInfo.gender == 1) {
          this.nan = true;
          this.nv = false;
          this.baomi = false;
          this.radio = 1;
        } else if (res.data.data.userInfo.gender == 2) {
          this.nan = false;
          this.nv = true;
          this.baomi = false;
          this.radio = 2;
        } else {
          this.nan = false;
          this.nv = false;
          this.baomi = true;
          this.radio = 0;
        }

        this.$axios({
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            "authToken": this.cooke,
            channel: "web",
            "Content-Type": "application/x-www-form-urlencoded",
          },
          transformRequest: [
            function (data) {
              data = qs.stringify(data);
              console.log(data);
              return data;
            },
          ],
          url: this.api + "/v1/profile/verifyNickname",
          method: "post",
          data: {
            nickname: this.text,
          },
        }).then((res) => {
          console.log(res);
          // 修改昵称
          this.$axios({
            headers: {
              device: "web",
              packageId: "1",
              version: "1.0.0",
              channel: "web",
              "authToken": this.cooke,
              "Content-Type": "application/x-www-form-urlencoded",
            },
            url: this.api + "/v1/profile/modifyNickname",
            method: "get",
          }).then((res) => {
            if(res.data.code == 200){
              if(res.data.data.count > 0){
                this.isUpdateName = res.data.data.count
              }else{
                this.isUpdateName = 0
              }
            }else{
              this.isUpdateName = 0
            }
            console.log('剩余修改次数',res);
          });
      });
      })
  },
  methods: {
    changeSlide(data){
      this.$router.push(data);
    },
    aa(e) {
      var file = e.file;
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let fileResult = "";
        reader.readAsDataURL(file);
        //开始转
        reader.onload = function () {
          fileResult = reader.result;
        };
        //转 失败
        reader.onerror = function (error) {
          reject(error);
        };
        //转 结束  咱就 resolve 出去
        reader.onloadend = function () {
          resolve(fileResult);
        };
      });
    },
    handleAvatarSuccesss(res, file) {
      this.imageUrl1 = URL.createObjectURL(file.raw);
      console.log(res);
      this.$axios({
        headers: {
          device: "Web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
        },
        url: this.api + "/v1/profile/modifyAvatar",
        method: "post",
        data: {
          avatar: res,
        },
      }).then((res) => {
        this.$message.success('提交成功，请等待审核')
        this.data = res.data.data.avatar;
      });
    },
    beforeAvatarUploadd(file) {
      this.file = file;
      const isJPG = file.type === "image/png";
      const isJPG2 = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG && !isJPG2) {
        this.$message.error("上传图片只能是JPG或者png格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG2 || (isJPG && isLt2M);
    },

    async Baocun() {

      // 查重----过滤关键字
      let keyWord = await  this.$store.dispatch('fifWord',{key:"userNamelist",value:this.text})
      if(keyWord.state){
        this.text = keyWord.value;
      }else{
        return
      }

      // 如果没保存就 不请求接口
      let {nickname,desc,birthday,gender} =  this.Xpc.userInfo;
      let NowApi = encodeURIComponent(nickname + desc + gender + birthday);
      let copysData = encodeURIComponent(this.text + this.textarea + this.radio +  this.value1);
      if(NowApi == copysData){
        console.log('没有做更改操作');
        this.$message.success('提交成功，请等待审核')
        return
      }
      if(!this.text ||  this.text.trim().length == 0){
        this.$message.error('姓名不能为空')
        return
      }
      // 昵称查重
      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          "authToken": this.cooke,
          channel: "web",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            data = qs.stringify(data);
            console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/profile/verifyNickname",
        method: "post",
        data: {
          nickname: this.text,
        },
      }).then((res) => {
        console.log('昵称查重',res);
        if(res.data.code != 200){
           this.$message({
              message:res.data.message,
              type: 'warning'
            });
          return
        }
        // 判断当前昵称是否等于原昵称
        if(this.text !== this.Xpc.userInfo.nickname){
          // 修改昵称
          this.$axios({
            headers: {
              device: "web",
              packageId: "1",
              version: "1.0.0",
              channel: "web",
              "authToken": this.cooke,
              "Content-Type": "application/x-www-form-urlencoded",
            },
            transformRequest: [
              function (data) {
                data = qs.stringify(data);
                return data;
              },
            ],
            url: this.api + "/v1/profile/modifyNickname",
            method: "post",
            data: {
              nickname: this.text,
            },
          }).then((res) => {
            if(res.data.code == 200){
              console.log('修改昵称成功')
            }else{
              console.log('修改昵称失败')
            }
            // this.$message({
            //   message:res.data.data,
            //    type: 'warning'
            // })
            // console.log(res);
          });

        }

        // 保存数据
        this.$axios({
            headers: {
              device: "web",
              packageId: "1",
              version: "1.0.0",
              channel: "web",
              "authToken": this.cooke,
              "Content-Type": "application/x-www-form-urlencoded",
            },
            transformRequest: [
              function (data) {
                data = qs.stringify(data);
                console.log(data);
                return data;
              },
            ],
            url: this.api + "/v1/profile/modifyEx",
            method: "post",
            data: {
              region: this.Xpc.userInfo.region,
              birthday: this.value1,
              gender: this.radio,
              desc: this.textarea,
            },
          }).then((res) => {
            console.log(res);
            if (res.data.message !== "success") {
              this.tishi2 = true;
              setTimeout(() => {
                this.tishi2 = false;
              }, 2000);
            } else {
              this.$message({
                message:'提交成功，请等待审核',
                 type: 'success'
              })
              this.tishi = true;
              setTimeout(() => {
                this.tishi = false;
              }, 2000);
            }
          });
      });
    },
    Mingcheng(e, i) {
      console.log(e, i);
      if (e == 0 && i == 0) {
        this.$router.push("/personalc");
      }
      if (e == 0 && i == 1) {
        this.$router.push("/wodeguanzhu");
      }
      if (e == 0 && i == 2) {
        this.$router.push("/wodefensi");
      }
      if (e == 0 && i == 3) {
        this.$router.push("/lishiguankan");
      }
      if (e == 0 && i == 4) {
        this.$router.push("/wodezichan");
      }
      if (e == 0 && i == 5) {
        this.$router.push("/wodexinxi");
      }
      if (e == 1 && i == 0) {
        this.$router.push("/shezhiguanliyuan");
      }
      if (e == 1 && i == 1) {
        this.$router.push("/guanlijinyan");
      }
      if (e == 1 && i == 2) {
        this.$router.push("/tianjiazhiboyuan");
      }
      if (e == 2 && i == 0) {
        this.$router.push("/wodeshouyi");
      }
      if (e == 2 && i == 1) {
        this.$router.push("/yonghupaihangbang");
      }
      // if (e == 3&&i == 0) {
      //     this.$router.push('/shipinfabu')
      // }
      // if (e == 3&&i == 1) {
      //     this.$router.push('/ziyuanguanli')
      // }
      if (e == 3 && i == 0) {
        this.$router.push("/zhiboshuju");
      }
      // if (e==4&&i==1) {
      //     this.$router.push('/shipinshuju')
      // }
    },
    Xiugaizhanghao() {
      this.$router.push("/xiugaishoujihao");
    },
    dianji(e) {
      this.b = e;
    },
    Nan() {
      this.nan = true;
      this.nv = false;
      this.baomi = false;
      this.radio = 1;
    },
    Nv() {
      this.nv = true;
      this.nan = false;
      this.baomi = false;
      this.radio = 2;
    },
    Baomi() {
      this.baomi = true;
      this.nan = false;
      this.nv = false;
      this.radio = 0;
    },
  },
  components: {
    Nav,slide
  },
};
</script>

<style scoped lang='scss'>
.xzcxzcxz {
  color: white;
}
.activeGender {
  background-color: #721edc !important;
  color: #fff !important;
}
.sanjiao {
  width: 0;
  height: 0;
  border-top: 11px solid #ffffff;
  /* border-bottom-width: 11px; */
  /* border-radius: 0px; */
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  margin: 0 auto;
  margin-top: 15px;
}
.personal-bottom-bottom-left .el-collapse {
  width: 100%;
  background: #f7f8fa;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
.personal {
  width: 100vw;
  background: #f7f8fa;
  .xzcxzcxz {
    color: rgba(114, 30, 220, 1) !important;
  }
  .personal-bottom {
    background-color: #f7f8fa;
  }
  .personal-bottom-top {
    width: 100%;
    height: 60px;
    min-width: 1240px;
    background-color: #fff;
  }
  .personal-bottom-top-div {
    width: 1240px;
    height: 60px;
    margin: 0 auto;
    color: #333;
    font-size: 23px;
    line-height: 60px;
    display: flex;
    align-items: center;
  }
  .personal-bottom-top-div-div {
    width: 6px;
    height: 50px;
    background-color: #721edc;
    border-radius: 6px;
  }
}
.personal-bottom-bottom {
  width: 1200px;
  /* height: calc(100vh - 105px); */
  margin: 0 auto;
  display: flex;
  background-color: #f7f8fa;
  min-width: 1200px;
  .personal-bottom-bottom-left {
    width: 190px;
    height: 100%;
    background-color: #fff;
    margin-top: 16px;
    color: #333;
    .myel-collapse-item {
      width: 190px;
    }
    .prent_item {
      text-align: center;
      width: 100%;
      height: 100%;
      display: flex;
      .parent_icon {
        display: flex;
        align-items: center;
      }
      .parent_name {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
    .child_item {
      color: #a6a6a6;
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #f2f2f2;
      .child_img {
        display: flex;
        align-items: center;
      }
      .child_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
.personal-bottom-bottom-right {
  margin-left: 12px;
  height: 100%;
  flex: 2;
  max-width: 998px;
  background-color: #fff;
  padding: 30px 20px;
  box-sizing: border-box;
  margin-top: 16px;
}
.personal-bottom-bottom-right-top {
  background-color: #fff;
  display: flex;
  align-items: center;
  .xinxi {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .xinxi:hover {
    color: #721edc;
  }
}

.personal-bottom-bottom-right-bottom {
  height: calc(94% - 15px);
  margin-top: 25px;
  border-top: 1px solid #dadada;
  box-sizing: border-box;
}
.daohang {
  display: flex;
  color: white;
  width: 500px;
  margin-left: 20px;
}
.xinxi {
  display: flex;
  align-items: center;
  font-size: 16px;
}
.biao {
  width: 16px;
  height: 16px;
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
}
input {
  outline: none;
  border: 1px solid #464646;
}
input:focus {
  border: none;
}
</style>
<style>
.touxiang .avatar-uploader .el-upload {
  /* border: 1px dashed #d9d9d9; */
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-left: 50px;
}
.touxiang .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.touxiang .avatar-uploader-icon {
  /* font-size: 16px; */
  color: #8c939d;
  width: 88px !important;
  height: 88px !important;
  /* line-height: 178px; */
  text-align: center;
}
.touxiang .avatar {
  width: 88px;
  height: 88px;
  display: block;
}
.colorBiao {
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
}

.xzcxzcxz {
  color: white;
}
.xingming .el-input {
  width: 330px;

  background-color: #464646;
  border-radius: 5px;
  color: #333;
}
.xingming .el-input__inner {
  background: #dadada;
  border: 1px solid #dadada;
  border-color:#dadada !important ;
  border-radius: 4px;
  color: #333;
}
.xingming .el-input.is-exceed .el-input__inner {
  border-radius: #464646 !important;
}
.xingming .el-input .el-input__count .el-input__count-inner {
  background: #f7f8fa;
  color: #333;
}
.shengri .el-input__inner {
 background: #dadada;
  color: #333;
  border: 1px solid #dadada;
}
.jianjie .el-textarea {
  width: 330px;
  margin-left: 19px;
}
.jianjie .el-textarea__inner {
  background: #dadada;
  color: #333;
  height: 120px;
  max-height: 130px;
  min-height: 130px;
}
.jianjie .el-textarea .el-input__count {
 background: #dadada;
  color: #333;
}
</style>
<style>
.personal-bottom-bottom-left .el-collapse-item__header {
  box-sizing: border-box;
  padding-left: 20px;
  background-color: #fff;
  border-bottom: 0px solid #ebeef5;
  color: #333;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
.personal-bottom-bottom-left .el-collapse-item__content {
  padding-bottom: 0px;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  border-bottom: 0px solid #ebeef5;
}
.personal-bottom-bottom-left .el-collapse-item__content > div {
  text-align: center;
}

.personal-bottom-bottom-left .el-collapse {
  border-top: 0px solid #ebeef5;
  width: 100%;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background-color: #f7f8fa;
}
</style>



// WEBPACK FOOTER //
// src/component/XiugaiPersonalC.vue